import { operatorEvents } from "@/operator/events/operatorEvents";

import { BaseController } from "./BaseController";

export class ProductionController extends BaseController {
    constructor() {
        super("production");
        operatorEvents.productionController.onInit.dispatch();
    }

    protected onBecomeVisible() {
        operatorEvents.productionController.onShown.dispatch();
    }

    protected onBecomeInvisible() {
        setTimeout(() => {
            operatorEvents.productionController.onHidden.dispatch();
        }, 500);
    }
}
